module.exports = __webpack_public_path__ + "static/img/products discription_cooler1.af516864.jpg";